import { render, staticRenderFns } from "./UpdateCustomerBepokePricePopUp.vue?vue&type=template&id=c36b49d6&scoped=true&"
import script from "./UpdateCustomerBepokePricePopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomerBepokePricePopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCustomerBepokePricePopUp.vue?vue&type=style&index=0&id=c36b49d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36b49d6",
  null
  
)

export default component.exports